var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5552 10.5552C13.3682 7.74233 17.1833 6.16211 21.1614 6.16211C25.1395 6.16211 28.9546 7.74233 31.7677 10.5552L49.4452 28.2302C52.2584 31.0431 53.8391 34.8584 53.8393 38.8368C53.8395 42.8151 52.2594 46.6306 49.4464 49.4439C46.6335 52.2572 42.8181 53.8378 38.8398 53.838C34.8614 53.8383 31.0459 52.2581 28.2327 49.4452L10.5552 31.7677C7.74233 28.9546 6.16211 25.1395 6.16211 21.1614C6.16211 17.1833 7.74233 13.3682 10.5552 10.5552ZM28.2302 42.3752L31.7677 45.9102C33.6431 47.7856 36.1867 48.8392 38.8389 48.8392C41.4911 48.8392 44.0347 47.7856 45.9102 45.9102C47.7856 44.0347 48.8392 41.4911 48.8392 38.8389C48.8392 36.1867 47.7856 33.6431 45.9102 31.7677L42.3752 28.2327L42.3702 28.2302C40.4873 26.3899 37.9547 25.3665 35.3219 25.3819C32.6892 25.3973 30.1688 26.4504 28.3076 28.3126C26.4464 30.1747 25.3947 32.6957 25.3807 35.3285C25.3666 37.9612 26.3889 40.4933 28.2302 42.3752Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.1dae5d5a911d97b7aa43655b0c0431cd.svg";
export { ForwardRef as ReactComponent };